// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.width-140[data-v-ab80d920] {\n    width: 140px;\n}\n", ""]);
// Exports
module.exports = exports;
